import { combineReducers } from '@reduxjs/toolkit'

import collectionPointBagDistribution from './collectionPointBagDistributionSlice'
import project from './projectSlice'

const reducer = combineReducers({
    collectionPointBagDistribution,
    project,
})

export default reducer
